(function($){

	$(document).ready(function(){

	});

	$(document).on('click','#blog-filter .blog-filter__trigger',function(e){
		e.preventDefault();
		$(this).siblings('.menu-wrapper').slideToggle();
	});
	
})(jQuery);